module.exports = __webpack_public_path__ + "static/media/profile-placeholder-colored.685899c3.svg";